import { render, staticRenderFns } from "./subscribes.vue?vue&type=template&id=409bba52&"
import script from "./subscribes.vue?vue&type=script&lang=js&"
export * from "./subscribes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports